<template>
  <div>
    <span
      v-if="
        (typeof ballotCandidateID === 'string' || typeof ballotCandidateID === 'number') &&
          documentID > 0
      "
    >
      <button
        class="button is-info is-light is-small is-outline is-rounded"
        @click.prevent="downloadPdf(ballotCandidateID)"
      >
        Pdf
      </button>
    </span>
    <span v-else>
      &nbsp;
    </span>
  </div>
</template>

<script>
export default {
  props: {
    ballotCandidateID: [Number, String],
    documentID: [Number, String],
    downloadPdf: Function
  }
}
</script>
